// 兼容IE
import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
// 引入 重写Object.assign()的原型方法
// import '@/utils/objAssignPolyfill'
import router from './router'
import store from './store/'
import VueCookies from 'vue-cookies'
import JsonViewer from 'vue-json-viewer'
import './components'

import './core/lazy_use'
import bootstrap from './core/bootstrap'
import '@/utils/filter' // global filter
import '@/plugins'
import utils from '@/utils'
// 引入国际化
import i18n from './lang'
// 引入自定义样式
import '@assets/styles/base/index.less'
import '@assets/styles/common/index.less'
import './assets/styles/style.less'

// 引入授权相关文件
// import axios from 'axios'
// import config from './config/authAbout/auth.config'
// import token from './config/authAbout/token'
// import login from './config/authAbout/loginUtil'
// import querystring from 'querystring'
import '@/permission' // permission control

// 授权相关全局参数
// Vue.prototype.$ajax = axios
// Vue.prototype.$config = config
// Vue.prototype.$token = token
// Vue.prototype.$login = login
// Vue.prototype.$querystring = querystring

Vue.config.productionTip = false

Vue.use(VueCookies)
Vue.use(router)
Vue.use(utils)
Vue.use(JsonViewer)

window.$globalHub = new Vue({
  router,
  store,
  i18n,
  created () {
    bootstrap()
  },
  render: h => h(App)
}).$mount('#app')
